// extracted by mini-css-extract-plugin
module.exports = {"Automotive2":"Automotive2_Automotive2__UN28l"};